export default __webpack_public_path__ + "static/media/message-t-icon.281f3ea5.svg";